import { defineStore } from 'pinia'
import { ref } from 'vue'
import { UsersService, type SuperUserUser as User, type SuperUserUser } from '@/types/generated'
import { useLocaleStore, supportedLocales, type Locale } from '../localStore'

export const useUserStore = defineStore('user', () => {
  const user = ref<User | undefined>(undefined)

  async function fetchUser() {
    const response = (await UsersService.usersRetrieve({ uuid: 'current' })) as SuperUserUser
    user.value = response

    // Apply the effective language (user preferred -> org default -> 'de')
    const effectiveLanguage = response.effective_language
    if (effectiveLanguage && supportedLocales.includes(effectiveLanguage as Locale)) {
      const localeStore = useLocaleStore()
      localeStore.setLocale(effectiveLanguage as Locale)
    }
  }

  return { user, fetchUser }
})
